import { doLogout } from "actions/authAction";

import {
  BASE_URL,
  BOOKING_URL,
  BOOKING_GET_ERROR,
  BOOKING_GET_LOADING,
  BOOKING_GET_SUCCESS,
  BOOKING_VIEW_ERROR,
  BOOKING_VIEW_LOADING,
  BOOKING_VIEW_SUCCESS,
  BOOKING_ADD_ERROR,
  BOOKING_ADD_LOADING,
  BOOKING_ADD_SUCCESS,
  BOOKING_HAS_DO_VIEW_URL,
  BOOKING_HAS_DO_VIEW_ERROR,
  BOOKING_HAS_DO_VIEW_LOADING,
  BOOKING_HAS_DO_VIEW_SUCCESS,
  BOOKING_HAS_DO_UPDATE_URL,
  BOOKING_HAS_DO_UPDATE_ERROR,
  BOOKING_HAS_DO_UPDATE_LOADING,
  BOOKING_HAS_DO_UPDATE_INVALID,
  BOOKING_HAS_DO_UPDATE_SUCCESS,
  BOOKING_LIST_ERROR,
  BOOKING_LIST_LOADING,
  BOOKING_LIST_SUCCESS,
  BOOKING_LIST_URL,
  STATUS_SISA_KUOTA,
  LIST_PAY_SUCCESS,
  PAY_CHANEL_SUCCESS,
  BOOKING_REFUND,
  BOOKING_UPLOAD_EXTERNAL_PO_ERROR,
  BOOKING_UPLOAD_EXTERNAL_PO_LOADING,
  BOOKING_UPLOAD_EXTERNAL_PO_SUCCESS,
  BOOKING_UPLOAD_EXTERNAL_PO_URL,
  BOOKING_SAVE_EXTERNAL_PO_URL,
  BOOKING_SAVE_EXTERNAL_PO_SUCCESS,
  BOOKING_SAVE_EXTERNAL_PO_ERROR,
  BOOKING_SAVE_EXTERNAL_PO_LOADING,
  BOOKING_VIEW_SUCCESS_OLD,
  BOOKING_VIEW_ERROR_OLD,
  BOOKING_VIEW_LOADING_OLD,
  BOOKING_VIEW_LOADING_NEW,
  BOOKING_VIEW_ERROR_NEW,
  BOOKING_VIEW_SUCCESS_NEW,
  BOOKING_UPDATE_BHP_PO_ERROR,
  BOOKING_UPDATE_BHP_PO_LOADING,
  BOOKING_UPDATE_BHP_PO_SUCCESS,
  BOOKING_UPDATE_BHP_PO_URL,
  GET_DATA_EXCEL_ERROR,
  GET_DATA_EXCEL_LOADING,
  GET_DATA_EXCEL_SUCCESS,
  GET_DATA_EXCEL_URL,
  CHECK_BOOKING_STATUS_ERROR,
  CHECK_BOOKING_STATUS_LOADING,
  CHECK_BOOKING_STATUS_SUCCESS,
  CHECK_BOOKING_STATUS_URL,
  BOOKING_UPLOAD_PEMBAYARAN_JPT_ERROR,
  BOOKING_UPLOAD_pEMBAYARAN_JPT_LOADING,
  BOOKING_UPLOAD_pEMBAYARAN_JPT_SUCCESS,
  BOOKING_UPLOAD_PEMBAYARAN_JPT_LOADING,
  BOOKING_UPLOAD_PEMBAYARAN_JPT_SUCCESS,
  BOOKING_VALIDATE_SHIP_CAPACITY_ERROR,
  BOOKING_VALIDATE_SHIP_CAPACITY_LOADING,
  BOOKING_VALIDATE_SHIP_CAPACITY_SUCCESS,
  BOOKING_UPLOAD_RECIPIENT_GOODS_ERROR,
  BOOKING_UPLOAD_RECIPIENT_GOODS_LOADING,
  BOOKING_UPLOAD_RECIPIENT_GOODS_SUCCESS,
  EDIT_PAYMENT_UPLOAD_ERROR,
  EDIT_PAYMENT_UPLOAD_LOADING,
  EDIT_PAYMENT_UPLOAD_SUCCESS,
} from "./constant";

export const BOOKING_GET_PREV_ONE_SUCCESS = "BOOKING_GET_PREV_ONE_SUCCESS";
export const BOOKING_UPDATE_STAT_REDC_SUCCESS =
  "BOOKING_UPDATE_STAT_REDC_SUCCESS";

const bookingGetError = (bool) => {
  return {
    type: BOOKING_GET_ERROR,
    bookingGetError: bool,
  };
};

const bookingGetLoading = (bool) => {
  return {
    type: BOOKING_GET_LOADING,
    bookingGetLoading: bool,
  };
};

const bookingGetSuccess = (bool, bookings) => {
  return {
    type: BOOKING_GET_SUCCESS,
    bookingGetSuccess: bool,
    bookings,
  };
};

const bookingGetExcelError = (bool) => {
  return {
    type: GET_DATA_EXCEL_ERROR,
    bookingGetExcelError: bool,
  };
};

const bookingGetExcelLoading = (bool) => {
  return {
    type: GET_DATA_EXCEL_LOADING,
    bookingGetExcelLoading: bool,
  };
};

const bookingGetExcelSuccess = (bool, bookingExcel) => {
  return {
    type: GET_DATA_EXCEL_SUCCESS,
    bookingGetExcelSuccess: bool,
    bookingExcel,
  };
};

const bookingViewError = (bool) => {
  return {
    type: BOOKING_VIEW_ERROR,
    bookingViewError: bool,
  };
};

const bookingViewLoading = (bool) => {
  return {
    type: BOOKING_VIEW_LOADING,
    bookingViewLoading: bool,
  };
};

const bookingViewSuccess = (bool, booking) => {
  return {
    type: BOOKING_VIEW_SUCCESS,
    bookingViewSuccess: bool,
    booking,
  };
};

const bookingViewErrorOld = (bool) => {
  return {
    type: BOOKING_VIEW_ERROR_OLD,
    bookingViewErrorOld: bool,
  };
};

const bookingViewLoadingOld = (bool) => {
  return {
    type: BOOKING_VIEW_LOADING_OLD,
    bookingViewLoadingOld: bool,
  };
};

const bookingViewSuccessOld = (bool, bookingOld) => {
  return {
    type: BOOKING_VIEW_SUCCESS_OLD,
    bookingViewSuccessOld: bool,
    bookingOld,
  };
};

const bookingViewErrorNew = (bool) => {
  return {
    type: BOOKING_VIEW_ERROR_NEW,
    bookingViewErrorNew: bool,
  };
};

const bookingViewLoadingNew = (bool) => {
  return {
    type: BOOKING_VIEW_LOADING_NEW,
    bookingViewLoadingNew: bool,
  };
};

const bookingViewSuccessNew = (bool, bookingNew) => {
  return {
    type: BOOKING_VIEW_SUCCESS_NEW,
    bookingViewSuccessNew: bool,
    bookingNew,
  };
};

const bookingAddError = (bool) => {
  return {
    type: BOOKING_ADD_ERROR,
    bookingAddError: bool,
  };
};

const bookingAddLoading = (bool) => {
  return {
    type: BOOKING_ADD_LOADING,
    bookingAddLoading: bool,
  };
};

const bookingAddSuccess = (bool, bookingAdded) => {
  return {
    type: BOOKING_ADD_SUCCESS,
    bookingAddSuccess: bool,
    bookingAdded,
  };
};

const bookingExternalPOUploadError = (bool) => {
  return {
    type: BOOKING_UPLOAD_EXTERNAL_PO_ERROR,
    bookingExternalPOUploadError: bool,
  };
};

const bookingExternalPOUploadLoading = (bool) => {
  return {
    type: BOOKING_UPLOAD_EXTERNAL_PO_LOADING,
    bookingExternalPOUploadLoading: bool,
  };
};

const bookingExternalPOUploadSuccess = (bool, bookingExternalPOUpload) => {
  return {
    type: BOOKING_UPLOAD_EXTERNAL_PO_SUCCESS,
    bookingExternalPOUploadSuccess: bool,
    bookingExternalPOUpload,
  };
};

const bookingPembayaranJPTUploadError = (bool) => {
  return {
    type: BOOKING_UPLOAD_PEMBAYARAN_JPT_ERROR,
    bookingPembayaranJPTUploadError: bool,
  };
};

const bookingPembayaranJPTUploadLoading = (bool) => {
  return {
    type: BOOKING_UPLOAD_PEMBAYARAN_JPT_LOADING,
    bookingPembayaranJPTUploadLoading: bool,
  };
};

const bookingPembayaranJPTUploadSuccess = (
  bool,
  bookingPembayaranJPTUpload
) => {
  return {
    type: BOOKING_UPLOAD_PEMBAYARAN_JPT_SUCCESS,
    bookingPembayaranJPTUploadSuccess: bool,
    bookingPembayaranJPTUpload,
  };
};
const bookingRecipientGoodsUploadError = (bool) => {
  return {
    type: BOOKING_UPLOAD_RECIPIENT_GOODS_ERROR,
    bookingRecipientGoodsUploadError: bool,
  };
};

const bookingRecipientGoodsUploadLoading = (bool) => {
  return {
    type: BOOKING_UPLOAD_RECIPIENT_GOODS_LOADING,
    bookingRecipientGoodsUploadLoading: bool,
  };
};

const bookingRecipientGoodsUploadSuccess = (
  bool,
  bookingRecipientGoodsUpload
) => {
  return {
    type: BOOKING_UPLOAD_RECIPIENT_GOODS_SUCCESS,
    bookingRecipientGoodsUploadSuccess: bool,
    bookingRecipientGoodsUpload,
  };
};
const editPaymentUploadError = (bool) => {
  return {
    type: EDIT_PAYMENT_UPLOAD_ERROR,
    editPaymentUploadError: bool,
  };
};

const editPaymentUploadLoading = (bool) => {
  return {
    type: EDIT_PAYMENT_UPLOAD_LOADING,
    editPaymentUploadLoading: bool,
  };
};

const editPaymentUploadSuccess = (bool, editPaymentUpload) => {
  return {
    type: EDIT_PAYMENT_UPLOAD_SUCCESS,
    editPaymentUploadSuccess: bool,
    editPaymentUpload,
  };
};

const bookingSaveExternalPOError = (bool) => {
  return {
    type: BOOKING_SAVE_EXTERNAL_PO_ERROR,
    bookingSaveExternalPOError: bool,
  };
};

const bookingSaveExternalPOLoading = (bool) => {
  return {
    type: BOOKING_SAVE_EXTERNAL_PO_LOADING,
    bookingSaveExternalPOLoading: bool,
  };
};

const bookingSaveExternalPOSuccess = (bool, bookingSaveExternalPO) => {
  return {
    type: BOOKING_SAVE_EXTERNAL_PO_SUCCESS,
    bookingSaveExternalPOSuccess: bool,
    bookingSaveExternalPO,
  };
};

const bookingValidateShipCapacityError = (bool) => {
  return {
    type: BOOKING_VALIDATE_SHIP_CAPACITY_ERROR,
    bookingValidateShipCapacityError: bool,
  };
};

const bookingValidateShipCapacityLoading = (bool) => {
  return {
    type: BOOKING_VALIDATE_SHIP_CAPACITY_LOADING,
    bookingValidateShipCapacityLoading: bool,
  };
};

const bookingValidateShipCapacitySuccess = (
  bool,
  bookingValidateShipCapacity
) => {
  return {
    type: BOOKING_VALIDATE_SHIP_CAPACITY_SUCCESS,
    bookingValidateShipCapacitySuccess: bool,
    bookingValidateShipCapacity,
  };
};

const bookingUpdateBhpPOError = (bool) => {
  return {
    type: BOOKING_UPDATE_BHP_PO_ERROR,
    bookingUpdateBhpPOError: bool,
  };
};

const bookingUpdateBhpPOLoading = (bool) => {
  return {
    type: BOOKING_UPDATE_BHP_PO_LOADING,
    bookingUpdateBhpPOLoading: bool,
  };
};

const bookingUpdateBhpPOSuccess = (bool, bookingUpdateBhpPO) => {
  return {
    type: BOOKING_UPDATE_BHP_PO_SUCCESS,
    bookingUpdateBhpPOSuccess: bool,
    bookingUpdateBhpPO,
  };
};

const bookingGetRefund = (bool, refund) => {
  return {
    type: BOOKING_REFUND,
    bookingGetRef: bool,
    refund,
  };
};

const bookingGetPrevOne = (Loading, Success, data, Err, errMsg) => {
  return {
    type: BOOKING_GET_PREV_ONE_SUCCESS,
    success: Success,
    error: Err,
    data,
    errMsg,
    Loading,
  };
};

const bookingUpdateStatRedc = (Loading, Success, data, Err, errMsg) => {
  return {
    type: BOOKING_UPDATE_STAT_REDC_SUCCESS,
    success: Success,
    error: Err,
    data,
    errMsg,
    Loading,
  };
};

const checkBookingStatusError = (bool) => {
  return {
    type: CHECK_BOOKING_STATUS_ERROR,
    checkBookingStatusError: bool,
  };
};

const checkBookingStatusLoading = (bool) => {
  return {
    type: CHECK_BOOKING_STATUS_LOADING,
    checkBookingStatusLoading: bool,
  };
};

const checkBookingStatusSuccess = (bool, checkBookingStatus) => {
  return {
    type: CHECK_BOOKING_STATUS_SUCCESS,
    checkBookingStatusSuccess: bool,
    checkBookingStatus,
  };
};

export function checkBookingStatusConsignee(data) {
  return (dispatch) => {
    dispatch(checkBookingStatusError(false));
    dispatch(checkBookingStatusSuccess(false, null));
    dispatch(checkBookingStatusLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    config = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };

    fetch(BASE_URL + CHECK_BOOKING_STATUS_URL, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }

        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(checkBookingStatusLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((response) => {
        if (response.status === 200) {
          dispatch(checkBookingStatusSuccess(true, response));
          dispatch(checkBookingStatusError(false));
        } else {
          dispatch(checkBookingStatusSuccess(false, null));
          dispatch(checkBookingStatusError(true));
          // alert(response.message)
        }
      })
      .catch((err) => {
        dispatch(checkBookingStatusSuccess(false, null));
        dispatch(checkBookingStatusError(true));
      });
  };
}

export function bookingUpdateStat(data) {
  return (dispatch) => {
    dispatch(bookingUpdateStatRedc(true, false, {}, false, ""));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + "konfirmasi_booking", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }

        if (!response.ok) {
          throw Error(response.statusText);
        }

        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          dispatch(bookingUpdateStatRedc(false, true, data.data, false, ""));
        } else {
          dispatch(bookingUpdateStatRedc(false, false, {}, true, data.msg));
        }
      })
      .catch((err) => {
        dispatch(
          bookingUpdateStatRedc(
            false,
            false,
            {},
            true,
            "Something went wrong, please try again later!"
          )
        );
      });
  };
}

export function bookingGetPrev(data) {
  return (dispatch) => {
    dispatch(bookingGetPrevOne(true, false, {}, false, ""));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + "booking/check", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }

        if (!response.ok) {
          throw Error(response.statusText);
        }

        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          dispatch(bookingGetPrevOne(false, true, data.data, false, ""));
        } else {
          dispatch(bookingGetPrevOne(false, false, {}, true, data.message));
        }
      })
      .catch((err) => {
        dispatch(
          bookingGetPrevOne(
            false,
            false,
            {},
            true,
            "Something went wrong, please try again later!"
          )
        );
      });
  };
}

export function bookingRefund(data) {
  return (dispatch) => {
    dispatch(bookingGetRefund(false, null));
    dispatch(bookingGetError(false));
    dispatch(bookingGetLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    let formData = new FormData();

    for (var key in data) {
      formData.append(key, data[key]);
    }

    if (token) {
      config = {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + BOOKING_URL + "/refund", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }

        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(bookingGetLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          dispatch(bookingGetRefund(true, data));
        } else {
          window.alert(data.message);
        }
      })
      .catch((err) => {
        dispatch(bookingGetError(true));
      });
  };
}

export function bookingExcelFetchAll() {
  return (dispatch) => {
    dispatch(bookingGetExcelSuccess(false, null));
    dispatch(bookingGetExcelError(false));
    dispatch(bookingGetExcelLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + GET_DATA_EXCEL_URL, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }

        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(bookingGetExcelLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(bookingGetExcelSuccess(true, data));
      })
      .catch((err) => {
        dispatch(bookingGetExcelError(true));
      });
  };
}

export function bookingExcelFetchWithDate(data) {
  return (dispatch) => {
    dispatch(bookingGetExcelSuccess(false, null));
    dispatch(bookingGetExcelError(false));
    dispatch(bookingGetExcelLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + GET_DATA_EXCEL_URL, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }

        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(bookingGetExcelLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(bookingGetExcelSuccess(true, data));
      })
      .catch((err) => {
        dispatch(bookingGetExcelError(true));
      });
  };
}

export function bookingFetchAll() {
  return (dispatch) => {
    dispatch(bookingGetSuccess(false, null));
    dispatch(bookingGetError(false));
    dispatch(bookingGetLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + BOOKING_URL, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }

        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(bookingGetLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(bookingGetSuccess(true, data));
      })
      .catch((err) => {
        dispatch(bookingGetError(true));
      });
  };
}

export function bookingFetchSub(path) {
  return (dispatch) => {
    dispatch(bookingGetSuccess(false, null));
    dispatch(bookingGetError(false));
    dispatch(bookingGetLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + BOOKING_URL + "/" + path, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }

        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(bookingGetLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(bookingGetSuccess(true, data));
      })
      .catch((err) => {
        dispatch(bookingGetError(true));
      });
  };
}

export function bookingFetchPage(params) {
  return (dispatch) => {
    dispatch(bookingGetSuccess(false, null));
    dispatch(bookingGetError(false));
    dispatch(bookingGetLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + BOOKING_URL + "/page", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }

        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(bookingGetLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(bookingGetSuccess(true, data));
      })
      .catch((err) => {
        dispatch(bookingGetError(true));
      });
  };
}

// dons
export function bookingFetchPageExcel(params) {
  return (dispatch) => {
    dispatch(bookingGetSuccess(false, null));
    dispatch(bookingGetError(false));
    dispatch(bookingGetLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + "/booking/export_page_excel", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }

        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(bookingGetLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(bookingGetSuccess(true, data));
      })
      .catch((err) => {
        dispatch(bookingGetError(true));
      });
  };
}

export function bookingFetchConsigneeReceived(param) {
  return (dispatch) => {
    dispatch(bookingGetSuccess(false, null));
    dispatch(bookingGetError(false));
    dispatch(bookingGetLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(param),
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + BOOKING_URL + "/consignee", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }

        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(bookingGetLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(bookingGetSuccess(true, data));
      })
      .catch((err) => {
        dispatch(bookingGetError(true));
      });
  };
}

// export function bookingAddOld(data) {
//   return (dispatch) => {
//     dispatch(bookingAddError(false));
//     dispatch(bookingAddSuccess(false, null));
//     dispatch(bookingAddLoading(true));

//     let token = localStorage.getItem('tolaut@token') || null;
//     let config = {};

//     config = {
//       method: 'POST',
//       headers: {
//         'Authorization': `Bearer ${token}`,
//         'Content-Type': 'application/json'
//       },
//       body: JSON.stringify(data)
//     };

//     fetch(BASE_URL + BOOKING_URL, config)
//     .then((response) => {
//       if (response.status === 401) {
//         dispatch(doLogout());
//       }

//       if (!response.ok) {
//         throw Error(response.statusText);
//       }

//       dispatch(bookingAddLoading(false));
//       return response;
//     })
//     .then((response) => response.json())
//     .then((booking) => {
//       dispatch(bookingAddSuccess(true, booking));
//     })
//     .catch((err) => {
//       dispatch(bookingAddError(true));
//     });
//   };
// };
export function bookingExternalPOSave(data) {
  return (dispatch) => {
    dispatch(bookingSaveExternalPOError(false));
    dispatch(bookingSaveExternalPOSuccess(false, null));
    dispatch(bookingSaveExternalPOLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    config = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };

    fetch(BASE_URL + BOOKING_SAVE_EXTERNAL_PO_URL, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }

        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(bookingSaveExternalPOLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((booking) => {
        dispatch(bookingSaveExternalPOLoading(false));
        dispatch(bookingSaveExternalPOSuccess(true, booking));
      })
      .catch((err) => {
        dispatch(bookingSaveExternalPOLoading(false));
        dispatch(bookingSaveExternalPOError(true));
      });
  };
}

export function bookingExternalPOSaveLCL(data) {
  return (dispatch) => {
    dispatch(bookingSaveExternalPOError(false));
    dispatch(bookingSaveExternalPOSuccess(false, null));
    dispatch(bookingSaveExternalPOLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    config = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };

    fetch(BASE_URL + BOOKING_SAVE_EXTERNAL_PO_URL + "/lcl", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }

        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(bookingSaveExternalPOLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((booking) => {
        dispatch(bookingSaveExternalPOLoading(false));
        dispatch(bookingSaveExternalPOSuccess(true, booking));
      })
      .catch((err) => {
        dispatch(bookingSaveExternalPOLoading(false));
        dispatch(bookingSaveExternalPOError(true));
      });
  };
}

export function bookingValidateShipCapacity(data) {
  return (dispatch) => {
    dispatch(bookingValidateShipCapacityError(false));
    dispatch(bookingValidateShipCapacitySuccess(false, null));
    dispatch(bookingValidateShipCapacityLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    config = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };

    fetch(BASE_URL + "/booking-new/validate-ship-max-capacity", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }

        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(bookingValidateShipCapacityLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((booking) => {
        dispatch(bookingValidateShipCapacityLoading(false));
        dispatch(bookingValidateShipCapacitySuccess(true, booking));
      })
      .catch((err) => {
        dispatch(bookingValidateShipCapacityLoading(false));
        dispatch(bookingValidateShipCapacityError(true));
      });
  };
}

export function bookingUploadExternalPO(data) {
  return (dispatch) => {
    dispatch(bookingExternalPOUploadError(false));
    dispatch(bookingExternalPOUploadSuccess(false, null));
    dispatch(bookingExternalPOUploadLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    let formData = new FormData();

    for (var key in data) {
      formData.append(key, data[key]);
    }

    config = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    };

    fetch(BASE_URL + BOOKING_UPLOAD_EXTERNAL_PO_URL, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }

        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(bookingExternalPOUploadLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((booking) => {
        if (booking.status === 200) {
          dispatch(bookingExternalPOUploadLoading(false));
          dispatch(bookingExternalPOUploadSuccess(true, booking));
        } else {
          window.alert(booking.message);
          dispatch(bookingExternalPOUploadSuccess(false, null));
          dispatch(bookingExternalPOUploadLoading(false));
          dispatch(bookingExternalPOUploadError(true));
        }
      })
      .catch((err) => {
        dispatch(bookingExternalPOUploadLoading(false));
        dispatch(bookingExternalPOUploadError(true));
      });
  };
}

export function bookingUploadPembayaranJPT(data) {
  return (dispatch) => {
    dispatch(bookingPembayaranJPTUploadError(false));
    dispatch(bookingPembayaranJPTUploadSuccess(false, null));
    dispatch(bookingPembayaranJPTUploadLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    let formData = new FormData();

    for (var key in data) {
      formData.append(key, data[key]);
    }

    config = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    };

    fetch(BASE_URL + "/booking-new/upload-invoice-jpt", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }

        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(bookingPembayaranJPTUploadLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((booking) => {
        if (booking.status === 200) {
          dispatch(bookingPembayaranJPTUploadLoading(false));
          dispatch(bookingPembayaranJPTUploadSuccess(true, booking));
        } else {
          window.alert(booking.message);
          dispatch(bookingPembayaranJPTUploadSuccess(false, null));
          dispatch(bookingPembayaranJPTUploadLoading(false));
          dispatch(bookingPembayaranJPTUploadError(true));
        }
      })
      .catch((err) => {
        dispatch(bookingPembayaranJPTUploadLoading(false));
        dispatch(bookingPembayaranJPTUploadError(true));
      });
  };
}

export function bookingUploadRecipientGoods(data) {
  return (dispatch) => {
    dispatch(bookingRecipientGoodsUploadError(false));
    dispatch(bookingRecipientGoodsUploadSuccess(false, null));
    dispatch(bookingRecipientGoodsUploadLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    let formData = new FormData();

    for (var key in data) {
      formData.append(key, data[key]);
    }

    config = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    };

    fetch(BASE_URL + "booking/consignee/goods-receipt", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }

        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(bookingRecipientGoodsUploadLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((booking) => {
        if (booking.success === true) {
          dispatch(bookingRecipientGoodsUploadLoading(false));
          dispatch(bookingRecipientGoodsUploadSuccess(true, booking));
        } else {
          window.alert(booking.message);
          dispatch(bookingRecipientGoodsUploadSuccess(false, null));
          dispatch(bookingRecipientGoodsUploadLoading(false));
          dispatch(bookingRecipientGoodsUploadError(true));
        }
      })
      .catch((err) => {
        dispatch(bookingRecipientGoodsUploadLoading(false));
        dispatch(bookingRecipientGoodsUploadError(true));
      });
  };
}

export function bookingUploadEditPayment(data) {
  return (dispatch) => {
    dispatch(editPaymentUploadError(false));
    dispatch(editPaymentUploadSuccess(false, null));
    dispatch(editPaymentUploadLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    let formData = new FormData();

    for (var key in data) {
      formData.append(key, data[key]);
    }

    config = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    };

    fetch(BASE_URL + "booking/reupload-payment-proof", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }

        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(editPaymentUploadLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((booking) => {
        if (booking.status === 200) {
          dispatch(editPaymentUploadLoading(false));
          dispatch(editPaymentUploadSuccess(true, booking));
        } else {
          window.alert(booking.message);
          dispatch(editPaymentUploadSuccess(false, null));
          dispatch(editPaymentUploadLoading(false));
          dispatch(editPaymentUploadError(true));
        }
      })
      .catch((err) => {
        dispatch(editPaymentUploadLoading(false));
        dispatch(editPaymentUploadError(true));
      });
  };
}

export function bookingUpdateBHPPO(data) {
  return (dispatch) => {
    dispatch(bookingUpdateBhpPOError(false));
    dispatch(bookingUpdateBhpPOSuccess(false, null));
    dispatch(bookingUpdateBhpPOLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    config = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };

    fetch(BASE_URL + BOOKING_UPDATE_BHP_PO_URL, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }

        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(bookingUpdateBhpPOLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((booking) => {
        dispatch(bookingUpdateBhpPOLoading(false));
        dispatch(bookingUpdateBhpPOSuccess(true, booking));
      })
      .catch((err) => {
        dispatch(bookingUpdateBhpPOLoading(false));
        dispatch(bookingUpdateBhpPOError(true));
      });
  };
}

export function bookingAdd(data) {
  return (dispatch) => {
    dispatch(bookingAddError(false));
    dispatch(bookingAddSuccess(false, null));
    dispatch(bookingAddLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    config = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };

    fetch(BASE_URL + "booking-new/create", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }

        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(bookingAddLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((booking) => {
        dispatch(bookingAddSuccess(true, booking));
      })
      .catch((err) => {
        dispatch(bookingAddError(true));
      });
  };
}

export function bookingFetchOneNew(id) {
  return (dispatch) => {
    dispatch(bookingViewSuccessNew(false, null));
    dispatch(bookingViewErrorNew(false));
    dispatch(bookingViewLoadingNew(true));
    dispatch(bookingAddError(false));

    dispatch(bookingUpdateBhpPOSuccess(false, null));
    dispatch(bookingExternalPOUploadSuccess(false, null));
    dispatch(bookingSaveExternalPOSuccess(false, null));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    let data = {
      booking_id: id,
    };

    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + "booking-new/packing-po", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }

        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(bookingViewLoadingNew(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(bookingViewSuccessNew(true, data));
      })
      .catch((err) => {
        dispatch(bookingViewErrorNew(true));
      });
  };
}

export function bookingFetchOne(id) {
  return (dispatch) => {
    dispatch(bookingViewSuccess(false, null));
    dispatch(bookingViewError(false));
    dispatch(bookingViewLoading(true));

    dispatch(bookingViewSuccessOld(false, null));
    dispatch(bookingViewErrorOld(false));
    dispatch(bookingViewLoadingOld(true));

    dispatch(bookingUpdateBhpPOSuccess(false, null));
    dispatch(bookingExternalPOUploadSuccess(false, null));
    dispatch(bookingSaveExternalPOSuccess(false, null));

    dispatch(bookingAddError(false));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    let data = {
      id: id,
    };

    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + BOOKING_URL + "/view", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }

        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(bookingViewLoadingOld(false));
        dispatch(bookingViewLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(bookingViewSuccess(true, data));

        dispatch(bookingViewSuccessOld(true, data));
      })
      .catch((err) => {
        dispatch(bookingViewError(true));
        dispatch(bookingViewErrorOld(true));
      });
  };
}

export function bookingFetchSi(id) {
  return (dispatch) => {
    dispatch(bookingViewSuccess(false, null));
    dispatch(bookingViewError(false));
    dispatch(bookingViewLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: id,
        }),
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + BOOKING_URL + "/shipping_intructions", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }

        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(bookingViewLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(bookingViewSuccess(true, data));
      })
      .catch((err) => {
        dispatch(bookingViewError(true));
      });
  };
}

export function bookingFetchRo(id) {
  return (dispatch) => {
    dispatch(bookingViewSuccess(false, null));
    dispatch(bookingViewError(false));
    dispatch(bookingViewLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: id,
        }),
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + BOOKING_URL + "/release_order", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }

        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(bookingViewLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(bookingViewSuccess(true, data));
      })
      .catch((err) => {
        dispatch(bookingViewError(true));
      });
  };
}

export function bookingConfirm(data) {
  return (dispatch) => {
    dispatch(bookingViewSuccess(false, null));
    dispatch(bookingAddSuccess(false, null));
    dispatch(bookingAddError(false));
    dispatch(bookingAddLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + BOOKING_URL + "/status", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }

        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(bookingAddLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((booking) => {
        if (booking.status == 200) {
          dispatch(bookingAddSuccess(true, booking));
        } else {
          window.alert(booking.message);
          dispatch(bookingAddError(true));
        }
      })
      .catch((err) => {
        dispatch(bookingAddError(true));
      });
  };
}

export function bookingPayment(data) {
  return (dispatch) => {
    dispatch(bookingAddSuccess(false, null));
    dispatch(bookingAddError(false));
    dispatch(bookingAddLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    let formData = new FormData();

    for (var key in data) {
      formData.append(key, data[key]);
    }

    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + BOOKING_URL + "/payment", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }

        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(bookingAddLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((booking) => {
        if (booking.status === 200) {
          dispatch(bookingAddSuccess(true, booking));
        } else {
          window.alert(booking.message);
          dispatch(bookingAddError(true));
        }
      })
      .catch((err) => {
        dispatch(bookingAddError(true));
      });
  };
}

export function bookingGenerateBL(data) {
  return (dispatch) => {
    dispatch(bookingAddSuccess(false, null));
    dispatch(bookingAddError(false));
    dispatch(bookingAddLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    let formData = new FormData();

    for (var key in data) {
      formData.append(key, data[key]);
    }

    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + BOOKING_URL + "/generate_bl", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }

        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(bookingAddLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((booking) => {
        if (booking.success) {
          dispatch(bookingAddSuccess(true, booking));
        } else {
          dispatch(bookingAddError(true));
        }
      })
      .catch((err) => {
        dispatch(bookingAddError(true));
      });
  };
}

export function bookingAmbilBarang(data) {
  return (dispatch) => {
    dispatch(bookingViewSuccess(false, null));
    dispatch(bookingAddSuccess(false, null));
    dispatch(bookingAddError(false));
    dispatch(bookingAddLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    let formData = new FormData();

    for (var key in data) {
      formData.append(key, data[key]);
    }

    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + BOOKING_URL + "/pengambilan_barang", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }

        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(bookingAddLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((booking) => {
        if (booking.status === 200) {
          dispatch(bookingViewSuccess(false, null));
          dispatch(bookingAddSuccess(true, booking));
        } else {
          dispatch(bookingAddError(true));
        }
      })
      .catch((err) => {
        dispatch(bookingAddError(true));
      });
  };
}

const bookingHasDOViewError = (bool) => {
  return {
    type: BOOKING_HAS_DO_VIEW_ERROR,
    bookingHasDOViewError: bool,
  };
};

const bookingHasDOViewLoading = (bool) => {
  return {
    type: BOOKING_HAS_DO_VIEW_LOADING,
    bookingHasDOViewLoading: bool,
  };
};

const bookingHasDOViewSuccess = (bool, bookinghdo) => {
  return {
    type: BOOKING_HAS_DO_VIEW_SUCCESS,
    bookingHasDOViewSuccess: bool,
    bookinghdo,
  };
};

const bookingHasDOUpdateError = (bool) => {
  return {
    type: BOOKING_HAS_DO_UPDATE_ERROR,
    bookingHasDOUpdateError: bool,
  };
};

const bookingHasDOUpdateLoading = (bool) => {
  return {
    type: BOOKING_HAS_DO_UPDATE_LOADING,
    bookingHasDOUpdateLoading: bool,
  };
};

const bookingHasDOUpdateInvalid = (bool, invalid) => {
  return {
    type: BOOKING_HAS_DO_UPDATE_INVALID,
    bookingHasDOUpdateInvalid: bool,
    invalid,
  };
};

const bookingHasDOUpdateSuccess = (bool) => {
  return {
    type: BOOKING_HAS_DO_UPDATE_SUCCESS,
    bookingHasDOUpdateSuccess: bool,
  };
};

export function bookingHasDOView(data) {
  return (dispatch) => {
    dispatch(bookingHasDOViewError(false));
    dispatch(bookingHasDOViewSuccess(false, null));
    dispatch(bookingHasDOViewLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    config = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };

    fetch(BASE_URL + BOOKING_HAS_DO_VIEW_URL, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }

        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(bookingHasDOViewLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((booking) => {
        dispatch(bookingHasDOViewSuccess(true, booking));
      })
      .catch((err) => {
        dispatch(bookingHasDOViewError(true));
      });
  };
}

export function bookingHasDOUpdate(data) {
  return (dispatch) => {
    dispatch(bookingHasDOUpdateError(false));
    dispatch(bookingHasDOUpdateSuccess(false));
    dispatch(bookingHasDOUpdateInvalid(false, null));
    dispatch(bookingHasDOUpdateLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    let formData = new FormData();

    for (var key in data) {
      formData.append(key, data[key]);
    }

    if (token) {
      config = {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + BOOKING_HAS_DO_UPDATE_URL, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }

        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(bookingHasDOUpdateLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          dispatch(bookingHasDOUpdateSuccess(true));
        } else {
          dispatch(bookingHasDOUpdateInvalid(true, data));
        }
      })
      .catch((err) => {
        dispatch(bookingHasDOUpdateError(true));
      });
  };
}

const statusKuota = (data, bool) => {
  return {
    type: STATUS_SISA_KUOTA,
    val: data,
    isLoad: bool,
  };
};

const bookingListError = (bool) => {
  return {
    type: BOOKING_LIST_ERROR,
    bookingListError: bool,
  };
};

const bookingListLoading = (bool) => {
  return {
    type: BOOKING_LIST_LOADING,
    bookingListLoading: bool,
  };
};

const bookingListSuccess = (bool, bookings) => {
  return {
    type: BOOKING_LIST_SUCCESS,
    bookingListSuccess: bool,
    bookings,
  };
};

export function getBookingList(data) {
  return (dispatch) => {
    dispatch(bookingListError(false));
    dispatch(bookingListSuccess(false, null));
    dispatch(bookingListLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + BOOKING_LIST_URL, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }

        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(bookingListLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          dispatch(bookingListSuccess(true, data));
        }
      })
      .catch((err) => {
        dispatch(bookingListError(true));
      });
  };
}

export function getStatusKuota(data) {
  return (dispatch) => {
    dispatch(statusKuota([], false));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + `empty_container/${data}`, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }

        if (!response.ok) {
          throw Error(response.statusText);
        }

        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          dispatch(statusKuota(data.data, true));
        } else {
          window.alert(data.message);
          dispatch(statusKuota([], false));
        }
      })
      .catch((err) => {
        dispatch(statusKuota([], false));
      });
  };
}

const listPaySuccess = (bool, listPay) => {
  return {
    type: LIST_PAY_SUCCESS,
    isLoad: bool,
    val: listPay,
  };
};

export function getListPayment() {
  return (dispatch) => {
    dispatch(listPaySuccess(true, []));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + "payment_channel", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }

        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(bookingListLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          dispatch(listPaySuccess(false, data.data));
        } else {
          window.alert(data.message);
          dispatch(listPaySuccess(false, []));
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch(listPaySuccess(false, []));
      });
  };
}

const isLoadPayChanel = (bool) => {
  return {
    type: PAY_CHANEL_SUCCESS,
    isLoad: bool,
  };
};

const generateCustomerCode = async (datas) => {
  let {
    institutionCode,
    brivaNo,
    custCode,
    nama,
    amount,
    keterangan,
    expiredDate,
    operator_id,
  } = datas;
  let data = {
    institutionCode,
    brivaNo,
    custCode,
    nama,
    amount: amount.toString(),
    keterangan,
    expiredDate,
    operator_id,
  };

  let token = localStorage.getItem("tolaut@token") || null;
  let config = {};

  if (token) {
    config = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
  } else {
    throw Error("Authentication error");
  }

  try {
    const response = await fetch(
      BASE_URL + `generate_customer_code/${datas.id_booking}`,
      config
    );

    if (response.status === 401) {
      return { status: 401 };
    }

    if (!response.ok) {
      return { status: 400, message: response.statusText };
    }

    const dataRes = await response.json();
    return dataRes;
  } catch (err) {
    console.log(err);
    return { status: 400, message: "error connection" };
  }
};

const updatechanel = (datas) => {
  return (dispatch) => {
    let { id_booking, id_payment, operator_id } = datas;
    let data = { id_booking, id_payment, operator_id };

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + "update_booking_payment", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }

        if (!response.ok) {
          throw Error(response.statusText);
        }

        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          dispatch(isLoadPayChanel(false));
          window.location.reload();
        } else {
          dispatch(isLoadPayChanel(false));
          window.alert(data.message);
        }
      })
      .catch((err) => {
        dispatch(isLoadPayChanel(false));
        console.log(err);
      });
  };
};

export const updatePayChannel = (datas) => {
  return async (dispatch) => {
    dispatch(isLoadPayChanel(true));

    if (datas.id_payment === 1) {
      const res = await generateCustomerCode(datas);

      if (res.status === 401) {
        dispatch(doLogout());
      }

      if (res.status === 200) {
        dispatch(updatechanel(datas));
      } else {
        dispatch(isLoadPayChanel(false));
        window.alert(res.message);
      }
    } else {
      dispatch(updatechanel(datas));
    }
  };
};

export const cekStatusPay = (datas) => {
  return async (dispatch) => {
    dispatch(isLoadPayChanel(true));

    let { id, ic, va, cc, op_id } = datas;
    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
    } else {
      throw Error("Authentication error");
    }

    try {
      const response = await fetch(
        BASE_URL + `payment_status/${id}/${ic}/${va}/${cc}/${op_id}`,
        config
      );
      if (response.status === 401) {
        dispatch(doLogout());
      }

      if (!response.ok) {
        throw Error(response.statusText);
      }

      const data = await response.json();

      if (data.status === 200) {
        dispatch(isLoadPayChanel(false));
        window.location.reload();
      } else {
        dispatch(isLoadPayChanel(false));
        window.alert(data.message);
      }
    } catch (err) {
      console.log(err);
    }
  };
};

const EDIT_STATUS_BOOKING_URL = "booking/update-status-booking";
export const EDIT_STATUS_BOOKING_LOADING = "EDIT_STATUS_BOOKING_LOADING";
export const EDIT_STATUS_BOOKING_SUCCESS = "EDIT_STATUS_BOOKING_SUCCESS";
export const EDIT_STATUS_BOOKING_ERROR = "EDIT_STATUS_BOOKING_ERROR";

const editStatusBookingLoading = (bool) => {
  return {
    type: EDIT_STATUS_BOOKING_LOADING,
    editStatusBookingLoading: bool,
  };
};

const editStatusBookingSuccess = (bool, editStatusBookingData) => {
  return {
    type: EDIT_STATUS_BOOKING_SUCCESS,
    editStatusBookingSuccess: bool,
    editStatusBookingData,
  };
};

const editStatusBookingError = (bool) => {
  return {
    type: EDIT_STATUS_BOOKING_ERROR,
    editStatusBookingError: bool,
  };
};

export function editStatusBooking(data) {
  return (dispatch) => {
    dispatch(editStatusBookingLoading(true));
    dispatch(editStatusBookingSuccess(false, {}));
    dispatch(editStatusBookingError(false));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    config = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };

    fetch(BASE_URL + EDIT_STATUS_BOOKING_URL, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }

        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(editStatusBookingLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((response) => {
        dispatch(editStatusBookingSuccess(true, response));
      })
      .catch((err) => {
        dispatch(editStatusBookingError(true));
      });
  };
}

export const HANDLE_EXPIRED_CONTAINER_LOADING =
  "HANDLE_EXPIRED_CONTAINER_LOADING";
export const HANDLE_EXPIRED_CONTAINER_SUCCESS =
  "HANDLE_EXPIRED_CONTAINER_SUCCESS";
export const HANDLE_EXPIRED_CONTAINER_ERROR = "HANDLE_EXPIRED_CONTAINER_ERROR";

const handleExpiredContainerLoading = (bool) => {
  return {
    type: HANDLE_EXPIRED_CONTAINER_LOADING,
    handleExpiredContainerLoading: bool,
  };
};

const handleExpiredContainerSuccess = (bool, expiredContainer) => {
  return {
    type: HANDLE_EXPIRED_CONTAINER_SUCCESS,
    handleExpiredContainerSuccess: bool,
    expiredContainer,
  };
};

const handleExpiredContainerError = (bool) => {
  return {
    type: HANDLE_EXPIRED_CONTAINER_ERROR,
    handleExpiredContainerError: bool,
  };
};

export function handleExpiredContainer(data) {
  return (dispatch) => {
    dispatch(handleExpiredContainerLoading(true));
    dispatch(handleExpiredContainerSuccess(false, null));
    dispatch(handleExpiredContainerError(false));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + "booking/status", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(handleExpiredContainerLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((expiredContainer) => {
        if (expiredContainer.success === true) {
          dispatch(handleExpiredContainerSuccess(true, expiredContainer));
        } else {
          alert(expiredContainer.message);
        }
      })
      .catch((err) => {
        dispatch(handleExpiredContainerError(true));
      });
  };
}
